(() => {
  if (window.AaronsCategoryRFQ) {
    window.AaronsCategoryRFQ.initialize(document);
    return;
  }
  const instances = new Map();
  function initializeDialog(dialog) {
    if (dialog.dataset.quoteInitialized || typeof dialog.showModal !== 'function') return;
    const form = dialog.querySelector('[data-quote-form]');
    if (!form) return;
    dialog.dataset.quoteInitialized = 'true';
    const controller = new AbortController();
    const on = (target, type, handler) => target.addEventListener(type, handler, { signal: controller.signal });

    const sectionId = dialog.dataset.quoteDialog;
    const openers = [...document.querySelectorAll('[data-quote-open]')]
      .filter(button => button.dataset.quoteOpen === sectionId);
    const product = form.querySelector('[data-quote-product]');
    const quantity = form.querySelector('[data-quote-quantity]');
    const contactName = form.querySelector('[data-quote-name]');
    const email = form.querySelector('[data-quote-email]');
    const status = form.querySelector('[data-quote-status]');
    const submitButton = form.querySelector('[data-quote-submit]');
    const submitLabel = form.querySelector('[data-quote-submit-label]');
    const originalSubmitLabel = submitLabel?.textContent;
    const success = form.querySelector('[data-quote-success]');
    const serverErrors = form.querySelector('[data-quote-server-errors]');
    const steps = [...form.querySelectorAll('[data-quote-step]')];
    let currentStep = serverErrors && product?.value.trim() && quantity?.querySelector('input:checked') ? 2 : 1;
    let opener = null;
    let backdropPressed = false;
    let isSubmitting = false;
    let submitResetTimer = 0;

    instances.set(dialog, () => {
      if (dialog.open) dialog.close();
      controller.abort();
      window.clearTimeout(submitResetTimer);
      delete dialog.dataset.quoteInitialized;
      openers.forEach(button => { button.disabled = true; });
      document.documentElement.classList.toggle('aarons-category-rfq-open', Boolean(document.querySelector('.aarons-category-rfq[open]')));
      instances.delete(dialog);
    });

    function setError(input, selector, message) {
      input.setAttribute('aria-invalid', String(Boolean(message)));
      const error = form.querySelector(selector);
      error.textContent = message;
      error.hidden = !message;
    }

    function validateProject() {
      const formatMessage = product.value.trim() ? '' : 'Enter a product type.';
      const selected = quantity.querySelector('input:checked');
      const quantityMessage = selected ? '' : 'Select an estimated quantity.';
      setError(product, '[data-quote-product-error]', formatMessage);
      setError(quantity, '[data-quote-quantity-error]', quantityMessage);
      return formatMessage ? product : quantityMessage ? quantity.querySelector('input') : null;
    }

    function validateContact() {
      const nameMessage = contactName.value.trim() ? '' : 'Enter your contact name.';
      const emailMessage = !email.value.trim() ? 'Enter a business email.' : email.validity.valid ? '' : 'Enter a valid business email.';
      setError(contactName, '[data-quote-name-error]', nameMessage);
      setError(email, '[data-quote-email-error]', emailMessage);
      return nameMessage ? contactName : emailMessage ? email : null;
    }

    function showStep(number, focusTarget) {
      currentStep = number;
      steps.forEach(step => { step.hidden = Number(step.dataset.quoteStep) !== number; });
      form.querySelectorAll('[data-quote-marker]').forEach(marker => {
        if (Number(marker.dataset.quoteMarker) === number) marker.setAttribute('aria-current', 'step');
        else marker.removeAttribute('aria-current');
      });
      dialog.scrollTop = 0;
      if (dialog.open) (focusTarget || (number === 1 ? product : contactName))?.focus({ preventScroll: true });
    }

    function openDialog(button) {
      if (button) {
        opener = button;
        const suggested = button.dataset.quoteProduct;
        if (product && suggested && (!product.value.trim() || product.value === dialog.dataset.quoteDefaultProduct)) product.value = suggested;
      }
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('aarons-category-rfq-open');
      if (success) success.focus({ preventScroll: true });
      else showStep(currentStep, serverErrors || undefined);
    }

    openers.forEach(button => {
      on(button, 'click', event => {
        event.preventDefault();
        openDialog(button);
      });
      button.disabled = false;
    });
    on(dialog.querySelector('[data-quote-close]'), 'click', () => dialog.close());
    on(dialog, 'close', () => {
      document.documentElement.classList.toggle('aarons-category-rfq-open', Boolean(document.querySelector('.aarons-category-rfq[open]')));
      backdropPressed = false;
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    });
    const outside = event => {
      const box = dialog.getBoundingClientRect();
      return event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom;
    };
    on(dialog, 'pointerdown', event => { backdropPressed = event.target === dialog && outside(event); });
    on(dialog, 'pointercancel', () => { backdropPressed = false; });
    on(dialog, 'click', event => {
      if (backdropPressed && event.target === dialog && outside(event)) dialog.close();
      backdropPressed = false;
    });

    if (!success) {
      form.noValidate = true;
      on(form.querySelector('[data-quote-next]'), 'click', () => {
        const invalid = validateProject();
        showStep(invalid ? 1 : 2, invalid);
      });
      on(form.querySelector('[data-quote-back]'), 'click', () => showStep(1));
      on(product, 'input', () => {
        if (product.value.trim()) setError(product, '[data-quote-product-error]', '');
      });
      on(quantity, 'change', () => setError(quantity, '[data-quote-quantity-error]', ''));
      for (const [input, selector] of [[contactName, '[data-quote-name-error]'], [email, '[data-quote-email-error]']]) {
        on(input, 'input', () => {
          if (input.value.trim() && input.validity.valid) setError(input, selector, '');
        });
      }

      function resetSubmitting() {
        isSubmitting = false;
        form.removeAttribute('aria-busy');
        submitButton.disabled = false;
        submitLabel.textContent = originalSubmitLabel;
        status.textContent = '';
      }

      on(form, 'submit', event => {
        if (isSubmitting) {
          event.preventDefault();
          return;
        }
        const invalidProject = validateProject();
        if (invalidProject) {
          event.preventDefault();
          showStep(1, invalidProject);
          return;
        }
        if (currentStep === 1) {
          event.preventDefault();
          showStep(2);
          return;
        }
        const invalidContact = validateContact();
        if (invalidContact) {
          event.preventDefault();
          showStep(2, invalidContact);
          return;
        }
        if (event.defaultPrevented) return;
        isSubmitting = true;
        form.setAttribute('aria-busy', 'true');
        submitButton.disabled = true;
        submitLabel.textContent = 'Sending…';
        status.textContent = 'Sending your RFQ…';
        // Keep Shopify's native contact POST and challenge handlers in control.
        // A challenge handler may cancel this event before it submits again.
        submitResetTimer = window.setTimeout(() => { if (event.defaultPrevented) resetSubmitting(); }, 0);
      });
      on(window, 'pageshow', resetSubmitting);
      showStep(currentStep);
    }

    if (success || serverErrors) openDialog();
  }

  function initialize(root) {
    if (root.matches?.('.aarons-category-rfq[data-quote-dialog]')) initializeDialog(root);
    root.querySelectorAll('.aarons-category-rfq[data-quote-dialog]').forEach(initializeDialog);
  }

  window.AaronsCategoryRFQ = { initialize };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [dialog, destroy] of instances) if (event.target === dialog || event.target.contains(dialog)) destroy();
  });
})();
